<template>
  <div class="updateOrderGroup">
    <el-dialog
            title="订单分组"
            :visible="true"
            @close="handleClose"
            width="460px"
    >
      <el-form ref="form" :model="form" label-width="50px">
        <el-form-item label="分组:">
          <el-select v-model="form.orderGroupId" placeholder="请选择" size="small" style="width: 100%;">
            <el-option v-for="item in orderGroupList" :key="item.id" :value="item.id" :label="item.title"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button size="small" type="primary" @click="onSave">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "updateOrderGroup",
    data(){
      return{
        form: {
          orderGroupId: ''
        },
        orderGroupList:[]
      }
    },
    props: {
      orderIdList: {
        type: Array,
        default: ()=>([])
      }
    },
    created() {
      this.getOrderGroupListAll()
    },
    methods: {
      async getOrderGroupListAll() {
        try {
          const response = await this.$http.get('/orderGroup/listAll')
          if (response.data) {
            this.orderGroupList = response.data.data && response.data.data.length ? response.data.data: []
          } else {
            this.orderGroupList = []
          }
        } catch (error) {
          console.error(error)
        }
      },
      async onSave(){
        if (this.form.orderGroupId === ''){
          this.$modal.msgError("请选择分组");
          return;
        }
        this.$confirm("确定要分组吗？", {
          confirmButtonText: "确定",
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: "退出",
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        })
          .then(async () => {
            const params = {
              orderGroupId: this.form.orderGroupId,
              orderIdList: this.orderIdList
            }
            console.log(params)
            const res = await this.$http.post("order/updateOrderGroup", params);
            if (res.data.code === 200) {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
            }
            this.$options.confirm(true)
          })
          .catch(() => {});
      },
      handleClose() {
        this.$options.cancel('cancel')
      }
    }
  }
</script>

<style scoped lang="less">
.updateOrderGroup{
  .dialog-footer{
    display: flex;
    align-items: end;
    justify-content: right;
  }
}
</style>
